<div class="chip" [style.font-size]="size + 'rem'">
  <span
    class="badge badge-pill badge-kinograylight"
    *ngFor="let item of data"
    [ngClass]="{ active: ifSelected(item), disabled: item.active === false }"
    (click)="selectItem(item)"
    [ngbTooltip]="disabledChipMessage"
    placement="top-left"
    [disableTooltip]="item?.id !== 2">
    <span *ngIf="!multiselect">{{ translationPrefix + item | translate }}</span>
    <span *ngIf="multiselect">{{ item.name }}</span>
  </span>
</div>
